<nz-layout class="h-screen overflow-hidden">
  <nz-header class="px-0! h-21!">
    <app-admin-header slug="admin"></app-admin-header>
  </nz-header>

  <nz-layout class="admin-main">
    <nz-sider
      nzTheme="light"
      nzCollapsible
      [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="null"
      nzWidth="250px"
      class="border-r border-[#F1F1F1]"
      [class.admin-locked-surface]="isNoRoleUser()"
    >
      <!-- <div class="h-[66px] flex items-center pl-[13px]">
        <a
          class="flex items-center font-medium text-gray-900 title-font md:mb-0"
          routerLink="/"
          nz-tooltip
          nzTooltipPlacement="right"
          nzTooltipTitle="Home"
        >
          <img
            *ngIf="!isCollapsed"
            [src]="'assets/images/logo_with_name.png'"
            class="w-[130px] rounded-full overflow-hidden object-fill"
          />
          <img
            *ngIf="isCollapsed"
            [src]="'assets/images/icon-logo.png'"
            class="w-[50px] rounded-full overflow-hidden object-fill"
          />
        </a>
      </div> -->
      <app-admin-sidemenu [isCollapsed]="isCollapsed"></app-admin-sidemenu>
    </nz-sider>

    <nz-content
      class="overflow-y-auto bg-[#fafafa]"
      [ngStyle]="{ height: 'calc(100vh - 84px)' }"
      [class.admin-locked-surface]="isNoRoleUser()"
    >
      <router-outlet></router-outlet>
    </nz-content>

    @if (isNoRoleUser()) {
      <div class="admin-lock-overlay" aria-live="polite">
        <div class="admin-lock-card" role="status">
          <h3 class="admin-lock-title">Thank you for registering on EDMS.</h3>
          <p class="admin-lock-text">
            You have not been assigned a role yet, so you cannot access all system features. The
            system administrator will assign you a role within 24 hours. If you still have no role
            after that time, please contact the system administrator.
          </p>
        </div>
      </div>
    }
  </nz-layout>
</nz-layout>
